import { useState } from "react";

/*
  NOTE:
  This page is intentionally built with mock data.
  Later you will replace mock data with API calls.
*/

const mockCategories = [
  { id: 1, name: "GST" },
  { id: 2, name: "Audit" },
  { id: 3, name: "Income Tax" },
  { id: 4, name: "Corporate Compliance" }
];

const mockServices = {
  1: [
    { id: 101, name: "GST Monthly Return Filing" },
    { id: 102, name: "GST Annual Return Filing" },
    { id: 103, name: "GST TDS Filing" }
  ],
  2: [
    { id: 201, name: "Statutory Audit" },
    { id: 202, name: "Internal Audit" },
    { id: 203, name: "Tax Audit" }
  ]
};

const ServiceMasterPage = () => {

  const [selectedCategory, setSelectedCategory] = useState(1);
  const [selectedService, setSelectedService] = useState(null);
  const [activeTab, setActiveTab] = useState("general");

  const services = mockServices[selectedCategory] || [];

  return (
    <div className="grid grid-cols-12 gap-6">

      {/* ================= CATEGORY SIDEBAR ================= */}
      <div className="col-span-3">

        <div className="bg-white border border-slate-200 rounded-2xl p-4">

          <div className="flex justify-between items-center mb-4">
            <h3 className="font-black text-slate-900">Categories</h3>

            <button className="text-sm text-indigo-600 font-semibold">
              + Add
            </button>
          </div>

          <div className="space-y-2">

            {mockCategories.map(cat => (
              <button
                key={cat.id}
                onClick={() => {
                  setSelectedCategory(cat.id);
                  setSelectedService(null);
                }}
                className={`w-full text-left px-3 py-2 rounded-xl text-sm font-semibold transition ${
                  selectedCategory === cat.id
                    ? "bg-indigo-50 text-indigo-700"
                    : "text-slate-500 hover:bg-slate-50"
                }`}
              >
                {cat.name}
              </button>
            ))}

          </div>

        </div>
      </div>

      {/* ================= SERVICE LIST ================= */}
      <div className="col-span-4">

        <div className="bg-white border border-slate-200 rounded-2xl p-4">

          <div className="flex justify-between items-center mb-4">
            <h3 className="font-black text-slate-900">
              Service Templates
            </h3>

            <button className="text-sm text-indigo-600 font-semibold">
              + Add
            </button>
          </div>

          <div className="space-y-2">

            {services.map(service => (
              <button
                key={service.id}
                onClick={() => setSelectedService(service)}
                className={`w-full text-left px-3 py-2 rounded-xl text-sm font-semibold transition ${
                  selectedService?.id === service.id
                    ? "bg-indigo-50 text-indigo-700"
                    : "text-slate-500 hover:bg-slate-50"
                }`}
              >
                {service.name}
              </button>
            ))}

            {services.length === 0 && (
              <p className="text-sm text-slate-400">
                No services available
              </p>
            )}

          </div>

        </div>
      </div>

      {/* ================= SERVICE CONFIGURATION ================= */}
      <div className="col-span-5">

        <div className="bg-white border border-slate-200 rounded-2xl p-5 min-h-[400px]">

          {!selectedService && (
            <div className="text-center text-slate-400 pt-20">
              Select a service template to configure
            </div>
          )}

          {selectedService && (
            <>
              {/* Service Title */}
              <h3 className="text-lg font-black text-slate-900 mb-4">
                {selectedService.name}
              </h3>

              {/* CONFIG TABS */}
              <div className="flex gap-6 border-b border-slate-200 mb-5">

                {["general", "workflow", "automation", "sla"].map(tab => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`pb-2 text-sm font-semibold transition capitalize ${
                      activeTab === tab
                        ? "text-indigo-600 border-b-2 border-indigo-600"
                        : "text-slate-400 hover:text-indigo-600"
                    }`}
                  >
                    {tab}
                  </button>
                ))}

              </div>

              {/* TAB CONTENT */}
              <div className="text-sm text-slate-600">

                {activeTab === "general" && (
                  <div className="space-y-4">

                    <input
                      className="w-full border border-slate-200 rounded-xl px-3 py-2"
                      placeholder="Service Name"
                    />

                    <select className="w-full border border-slate-200 rounded-xl px-3 py-2">
                      <option>Frequency Type</option>
                      <option>Monthly</option>
                      <option>Quarterly</option>
                      <option>Yearly</option>
                    </select>

                    <textarea
                      className="w-full border border-slate-200 rounded-xl px-3 py-2"
                      placeholder="Description"
                    />

                  </div>
                )}

                {activeTab === "workflow" && (
                  <div>Workflow template builder will appear here.</div>
                )}

                {activeTab === "automation" && (
                  <div>Automation rules configuration.</div>
                )}

                {activeTab === "sla" && (
                  <div>SLA & deadline configuration.</div>
                )}

              </div>
            </>
          )}

        </div>

      </div>

    </div>
  );
};

export default ServiceMasterPage;
